import Modal from 'react-bootstrap/Modal'
import useForm from '../useForm'
import Button from './Button'
import { useParams } from 'react-router-dom'

function UpdatebankDetailsModal(props) {
    const { handleChange, values, seterrmsg, errmsg, message , setMessage} = useForm({
    bank_name: '',
    account_name:'',
    account_number: '',
    bvn: ''
    })
    const { token } = useParams();
    const id = props.id;

    const updateBankDetails = async(values, token, id) => {
      const sendOptions = {
        method : 'PATCH',
        headers: {
          "Content-Type" : "application/json",
          "Accept": "application/json",
          'Authorization': `Bearer ${token}`
         },
       body: JSON.stringify(values)
      }
      await fetch(`${process.env.REACT_APP_API_URL}/bank/update/${id}`, sendOptions)
      .then (response => response.json())
      .then (data => {
       if(data.msg !== 'Error: BVN does not match'){
         setTimeout(() => {
          props.onHide()
           setMessage('')
           window.location.reload();
         }, 3000)
        setMessage('Bank Details Updated')
       } else{
         setTimeout(() => {
           seterrmsg('')
         }, 3000)
         seterrmsg('Could not update bank details, please check your details and try again')
       }
      })
      .catch(err => console.log(err))
    }

    const handleBankDetailsSubmit = (e) => {
      e.preventDefault()
      updateBankDetails(values,token, id)
    }
    return (
        <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
        <h6 className='bankmodal-head'>Edit Bank Account</h6>
        </Modal.Header>
        <Modal.Body >
         <form onSubmit={handleBankDetailsSubmit}>
         {message ? <p className='text-success my3 message'>{message}</p> : <p className='text-danger my3 message'>{errmsg}</p>}
        <select
            id="bankCode"
            name="bank_name"
            className='bank-input'
            value={values.bank_name}
            onChange={handleChange}
        >
            <option value="" >Select Bank</option>
            <option value="Page MFBank" id="132" code="560">Page MFBank</option>
            <option value="Stanbic Mobile Money" id="133" code="304">Stanbic Mobile Money</option>
            <option value="FortisMobile" id="134" code="308">FortisMobile</option>
            <option value="TagPay" id="135" code="328">TagPay</option>
            <option value="FBNMobile" id="136" code="309">FBNMobile</option>
            <option value="First Bank of Nigeria" id="137" code="011">First Bank of Nigeria</option>
            <option value="Sterling Mobile" id="138" code="326">Sterling Mobile</option>
            <option value="Omoluabi Mortgage Bank" id="139" code="990">Omoluabi Mortgage Bank</option>
            <option value="ReadyCash (Parkway)" id="140" code="311">ReadyCash (Parkway)</option>
            <option value="Zenith Bank" id="141" code="057">Zenith Bank</option>
            <option value="Standard Chartered Bank" id="142" code="068">Standard Chartered Bank</option>
            <option value="eTranzact" id="143" code="306">Page MFBank</option>
            <option value="Fidelity Bank" id="144" code="070">Fidelity Bank</option>
            <option value="CitiBank" id="145" code="023">CitiBank</option>
            <option value="Unity Bank" id="146" code="215">Unity Bank</option>
            <option value="Access Money" id="147" code="323">Access Money</option>
            <option value="Eartholeum" id="148" code="302">Eartholeum</option>
            <option value="Hedonmark" id="149" code="324">Hedonmark</option>
            <option value="MoneyBox" id="150" code="325">MoneyBox</option>
            <option value="JAIZ Bank" id="151" code="301">JAIZ Bank</option>
            <option value="Ecobank Plc" id="152" code="050">Ecobank Plc</option>
            <option value="EcoMobile" id="153" code="307">EcoMobile</option>
            <option value="Fidelity Mobile" id="154" code="318">Fidelity Bank</option>
            <option value="TeasyMobile" id="155" code="319">TeasyMobile</option>
            <option value="NIP Virtual Bank" id="156" code="999">NIP Virtual Bank</option>
            <option value="VTNetworks" id="157" code="320">VTNetworks</option>
            <option value="Stanbic IBTC Bank" id="158" code="221">Stanbic IBTC Bank</option>
            <option value="Fortis Microfinance Bank" id="159" code="501">Fortis Microfinance Bank</option>
            <option value="PayAttitude Online" id="160" code="329">PayAttitude Online</option>
            <option value="ZenithMobile" id="161" code="322">ZenithMobile</option>
            <option value="ChamsMobile" id="162" code="303">ChamsMobile</option>
            <option value="SafeTrust Mortgage Bank" id="163" code="403">SafeTrust Mortgage Bank</option>
            <option value="Covenant Microfinance Bank" id="164" code="551">Covenant Microfinance Bank</option>
            <option value="Imperial Homes Mortgage Bank" id="165" code="415">Imperial Homes Mortgage Bank</option>
            <option value="NPF MicroFinance Bank" id="166" code="552">NPF MicroFinance Bank</option>
            <option value="Parralex" id="167" code="526">Parralex</option>
            <option value="Wema Bank" id="168" code="035">Wema Bank</option>
            <option value="Enterprise Bank" id="169" code="084">Enterprise Bank</option>
            <option value="Diamond Bank" id="170" code="063">Diamond Bank</option>
            <option value="Paycom" id="171" code="305">Paycom</option>
            <option value="SunTrust Bank" id="172" code="100">SunTrust Bank</option>
            <option value="Cellulant" id="173" code="317">Cellulant</option>
            <option value="ASO Savings and Loans" id="174" code="401">ASO Savings and Loans</option>
            <option value="Heritage" id="175" code="030">Heritage</option>
            <option value="Jubilee Life Mortgage Bank" id="176" code="402">Jubilee Life Mortgage Bank</option>
            <option value="GTBank Plc" id="177" code="058">GTBank Plc</option>
            <option value="Union Bank" id="178" code="032">Union Bank</option>
            <option value="Sterling Bank" id="179" code="232">Sterling Bank</option>
            <option value="Skye Bank" id="180" code="076">Skye Bank</option>
            <option value="Keystone Bank" id="181" code="082">Keystone Bank</option>
            <option value="Pagatech" id="182" code="327">Pagatech</option>
            <option value="Coronation Merchant Bank" id="183" code="559">Coronation Merchant Bank</option>
            <option value="FSDH" id="184" code="601">FSDH</option>
            <option value="Mkudi" id="185" code="313">Mkudi</option>
            <option value="First City Monument Bank" id="186" code="214">First City Monument Bank</option>
            <option value="FET" id="187" code="314">FET</option>
            <option value="TrustBond" id="188" code="523">TrustBond</option>
            <option value="GTMobile" id="189" code="315">GTMobile</option>
            <option value="United Bank for Africa" id="190" code="033">United Bank for Africa</option>
            <option value="Access Bank" id="191" code="044">Access Bank</option>
            <option value="TCF Bank" id="567" code="90115">TCF Bank</option>

        </select>

        <input  className='bank-input' type="text" placeholder='Account Number'  name='account_number' id='acct-no' value={values.account_number} onChange={handleChange}/>
        <input  className='bank-input' type="text" placeholder='Account Name'  name='account_name' id='acct-name' value={values.account_name} onChange={handleChange}/>
        <input  className='bank-input' type="text" placeholder='BVN'  name='bvn' id='bvn' value={values.bvn} onChange={handleChange}/>

       
        <Button type='submit'>
            Save
        </Button>
      </form>
         
        </Modal.Body>
      </Modal>
      )
}

export default UpdatebankDetailsModal

